import { parseNotificationCategory } from './categories';
import type { NotificationSubscription } from './subscriptions';
import { parseNotificationTopic } from './topics';

/**
 * Context to use when passing more information to SendGrid for the purposes of email analytics.
 */
export interface NotificationsContext {
    /**
     * Th object of the notification, what content was modified or created to trigger that
     * notification. For example: space_collection, change_request, comment...
     */
    notificationObject?: string;

    /**
     * The type of the notification for the purposes of analytics.
     */
    notificationType?: string;

    /**
     * The subscription of the notification for the purposes of analytics.
     */
    notificationSubscription?: NotificationSubscription;

    /**
     * An objectId to identify the object defined in notificationObject.
     */
    notificationObjectId?: string;
}

/**
 * Returns the context of a notification topic and category pair. It's used before we send the
 * Notification for SendGrid analytics, and when the notification has been sent for in-app analytics.
 */
export function getNotificationContext({
    topic,
    category,
}: {
    topic: string | null;
    category: string | null;
}): NotificationsContext {
    const parsedTopic = topic ? parseNotificationTopic(topic) : null;
    const parsedCategory = category ? parseNotificationCategory(category) : null;

    return {
        ...(topic && parsedTopic
            ? {
                  notificationObject: parsedTopic.type,
                  notificationObjectId: topic,
              }
            : {}),
        ...(parsedCategory
            ? {
                  notificationType: parsedCategory[0],
                  notificationSubscription: parsedCategory[1],
              }
            : {}),
    };
}
